// Heartbeat: decide si el servidor es alcanzable y lo publica en el store `conexion`.
// Uno solo por pestaña: lo arranca App.vue al entrar con sesión y se detiene al salir (logout).
// No reintenta ventas: eso es de la cola (Etapa 3).
import { HEARTBEAT } from '@/config/offline';
import { fetchWrapper } from '@/helpers/fetchWrapper';
import { useConexion } from '@/stores';

let activo = false;
let temporizador = null;
let pingEnCurso = null;

// Etapa 6 (D4): si el PRIMER ping falla (p. ej. F5 sin red), 2 reintentos a los 2 s en vez de 30 s.
// Así se llega a los 3 fallos de HEARTBEAT.fallosParaOffline y la franja aparece en ≈ 5 s, no en ≈ 60 s.
const REINTENTOS_ARRANQUE = 2;
const REINTENTO_ARRANQUE_MS = 2000;
let reintentosArranque = 0;

function intervaloActual() {
  return document.visibilityState === 'hidden' ? HEARTBEAT.intervaloSegundoPlanoMs : HEARTBEAT.intervaloMs;
}

function programarSiguiente() {
  clearTimeout(temporizador);
  temporizador = null;
  if (activo && reintentosArranque > 0) {
    reintentosArranque -= 1;
    temporizador = setTimeout(pingAhora, REINTENTO_ARRANQUE_MS);
    return;
  }
  const ms = intervaloActual();
  // null con la pestaña oculta = pausado hasta que vuelva a estar visible
  if (activo && ms) temporizador = setTimeout(pingAhora, ms);
}

// Ping inmediato. Si ya hay uno en curso, devuelve ese (nunca se solapan).
export function pingAhora() {
  if (!activo) return Promise.resolve();
  if (pingEnCurso) return pingEnCurso;
  const conexion = useConexion();
  conexion.verificando = true;
  pingEnCurso = fetchWrapper
    .raw('GET', HEARTBEAT.url, null, { timeoutMs: HEARTBEAT.timeoutMs, auth: HEARTBEAT.conAuth })
    // Etapa 3D (B): antes .then(({ status }) => {
    .then(({ status, reloj }) => {
      if (!activo) return; // se cerró sesión mientras volvía el ping
      if (reloj) conexion.registrarReloj(reloj); // Etapa 3D (B)
      // Fallo: sin respuesta (status 0: red o timeout) o proxy sin backend (502/503/504).
      // Cualquier otra respuesta, incluidos 401 y 500, es «servidor alcanzable».
      const ok = status !== 0 && !HEARTBEAT.statusDeFallo.includes(status);
      if (ok) reintentosArranque = 0; // con respuesta, se vuelve al intervalo normal
      conexion.registrarPing(ok, status);
    })
    .finally(() => {
      conexion.verificando = false;
      pingEnCurso = null;
      programarSiguiente();
    });
  return pingEnCurso;
}

function alCambiarVisibilidad() {
  if (document.visibilityState === 'visible') pingAhora();
  else programarSiguiente();
}

// Eventos online/offline del navegador: solo adelantan el ping; no cambian modoOffline por sí solos
function alCambiarRed() {
  pingAhora();
}

export function iniciarHeartbeat() {
  if (activo) return;
  activo = true;
  reintentosArranque = REINTENTOS_ARRANQUE;
  document.addEventListener('visibilitychange', alCambiarVisibilidad);
  window.addEventListener('online', alCambiarRed);
  window.addEventListener('offline', alCambiarRed);
  pingAhora();
}

export function detenerHeartbeat() {
  activo = false;
  reintentosArranque = 0;
  clearTimeout(temporizador);
  temporizador = null;
  document.removeEventListener('visibilitychange', alCambiarVisibilidad);
  window.removeEventListener('online', alCambiarRed);
  window.removeEventListener('offline', alCambiarRed);
  useConexion().$reset();
}
